import React from "react";
import { string, bool } from "prop-types";
import { twMerge } from "tailwind-merge";

import RadioIcon from "./Icons/RadioIcon";
import Typography from "@components/shared/Typography";
import { withTabNavigation } from "@hoc/withTabNavigation";
import Icon from "./Icons/Icon";

const Label = withTabNavigation("label");

const Radio = ({
  label,
  fullWidth = false,
  disabled,
  className,
  checked,
  hideInput,
  dataId,
  ...props
}) => {
  return (
    <Label
      className={twMerge(
        "flex items-center text-black cursor-pointer select-none relative",
        "disabled:text-greyLight disabled:pointer-events-none",
        fullWidth && "w-full",
        className
      )}
      data-id={dataId}
      disabled={disabled}
    >
      <div className="flex items-center">
        {!hideInput && (
          <>
            <input
              checked={checked}
              className="hidden"
              disabled={disabled}
              type="radio"
              {...props}
            />
            <Icon
              className="size-6 mr-4"
              icon={
                <RadioIcon
                  checked={checked}
                  className="bg-transparent size-6"
                />
              }
            />
          </>
        )}
        <Typography className="text-lg/tight m-0 font-semibold">
          {label}
        </Typography>
      </div>
    </Label>
  );
};

Radio.propTypes = {
  label: string.isRequired,
  fullWidth: bool,
  disabled: bool,
  className: string,
  checked: bool,
  hideInput: bool,
  dataId: string,
};

export default Radio;
